import { useContext } from 'react';

import APIContext from 'src/contexts/APIContext';

export default () => useContext(APIContext);
